export default __webpack_public_path__ + "static/media/405e4be1-3493-49d2-ab92-4eb256200ac5.cb565999.webp";